import { css } from "styled-components";

export const size = (props) => {
  if (props.sm) {
    return css`
      height: 12px;
      width: 12px;
      flex: 0 0 12px;
    `;
  } else if (props.md) {
    return css`
      height: 20px;
      width: 20px;
      flex: 0 0 20px;
    `;
  }

  return css`
    height: 12px;
    width: 12px;
    flex: 0 0 12px;
  `;
};

export const margin = () => css`
  margin-right: 0.5rem;
`;

export const background = (props) => {
  if (props.primary)
    return css`
      background: red;
    `;
  else if (props.success)
    return css`
      background: green;
    `;
  else if (props.warning)
    return css`
      background: yellow;
    `;
  else if (props.danger)
    return css`
      background: red;
    `;
};
